export enum EAgentPermissions {
  RESEND_NOTIFICATIONS = 'RESEND_NOTIFICATIONS',
  PUSH_APPLICATION = 'PUSH_APPLICATION',
  UPDATE_APPLICATION_DETAILS = 'UPDATE_APPLICATION_DETAILS',
  CANCEL_APPLICATION = 'CANCEL_APPLICATION',
  UPDATE_APPLICATION_CHANGE_REQUEST = 'UPDATE_APPLICATION_CHANGE_REQUEST',
  UPDATE_APPLICATION_STATE = 'UPDATE_APPLICATION_STATE',
  UPDATE_APPLICATION_REVIEWER = 'UPDATE_APPLICATION_REVIEWER',
  TRIGGER_APPLICATION_EVENT = 'TRIGGER_APPLICATION_EVENT',
  VIEW_APPLICATION_PROCESSING_FAILURE_TRACKER = 'VIEW_APPLICATION_PROCESSING_FAILURE_TRACKER',
  RESOLVE_APPLICATION_PROCESSING_FAILURE = 'RESOLVE_APPLICATION_PROCESSING_FAILURE',
  MOVE_APPLICATION_TO_PAYMENT_PENDING = 'MOVE_APPLICATION_TO_PAYMENT_PENDING',
}
